export default {
  title: {
    en: 'YAY!',
  },
  text: {
    en: 'We will notify you when <br />the product becomes available',
  },
}
